'use strict'

const addComponentEventListener = require('../addComponentEventListener')

module.exports = ({ services, errorBoundaries }) => {
  const itemReady = (actions, api, component) => (
    scoped$w,
    itemData,
    index
  ) => {
    const scopeId = { componentId: component.uniqueId, itemId: itemData._id }
    const scope = services().scopeFactory.createDetailsScope(scopeId)
    services().scopeStore.setScope(scopeId, scope)
    scope.pageReady(scoped$w.scoped)
  }

  const itemRemoved = component => itemData => {
    const scopeId = { componentId: component.uniqueId, itemId: itemData._id }
    services().scopeStore.removeScope(scopeId)
  }

  return {
    isValidContext({ connectionConfig }) {
      return true
    },

    bindToComponent(
      { connectionConfig: { properties, events, filters }, component },
      actions,
      api
    ) {
      addComponentEventListener(
        component,
        'onItemReady',
        itemReady(actions, api, component),
        errorBoundaries
      )
      addComponentEventListener(
        component,
        'onItemRemoved',
        itemRemoved(component),
        errorBoundaries
      )
    },

    currentRecordModified({ component }, actions, updatedFields) {},

    async recordSetLoaded(
      { connectionConfig: { properties }, component },
      actions
    ) {},

    currentViewChanged(componentAdapterContext, actions) {},

    currentIndexChanged(componentAdapterContext, actions, isNewRecord) {}
  }
}



// WEBPACK FOOTER //
// ./adapters/repeater/detailsRepeaterAdapter.js